const passengers = {
  table: {
    headers: {
      name: 'Name',
      email: 'E-Mail',
      created: 'Erstellungsdatum',
      id: 'Ausweis',
      profiles: 'Angehängte Profile',
      createdBy: 'Erstellt von',
      baseAddress: 'Privatadresse',
      occupationAddress: 'Arbeitsadresse',
      createdAt: 'Erstellt am',
      profile: 'Profil',
    },
  },
};

export default passengers;
